import { z } from "zod";

import type { INodeDesign } from "../types/index.ts";
import { FormatStrings } from "./FormatStrings.ts";
import { NodeBindings } from "./NodeBindings.ts";
import { NodeRole } from "./NodeRole.ts";
import { NodeSettings } from "./NodeSettings.ts";
import { TriggerDesigns } from "./TriggerDesigns.ts";
import { VariableDesigns } from "./VariableDesigns.ts";

export const NodeDesigns: z.ZodType<INodeDesign<any>> = z.object({
  id: z.number(),
  typeId: z.string(),
  settings: NodeSettings.optional(),
  variables: VariableDesigns.optional(),
  children: z.lazy(() => NodeChildren).optional(),
  formatStrings: FormatStrings.optional(),
  platformTarget: z.string().optional(),
  role: NodeRole.optional(),
  triggers: TriggerDesigns.optional(),
  bindings: NodeBindings.optional(),
});

export type NodeDesigns = z.infer<typeof NodeDesigns>;

export const NodeChildren = z.record(z.string(), NodeDesigns.or(NodeDesigns.array()).optional());
